import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

import colours from '~/utils/colours';
import { createFontAwesomeIcon } from '~/App/Components/Attributes/util';

const InfoIcon = createFontAwesomeIcon(faInfoCircle);

const Container = styled.div`
  text-align: right;
  color: ${(props) => props.textColor || colours.greyMediumDark};
`;

export default function InputHelpBlock({ maxContacts, contactCount }) {
  const error = useMemo(
    () => contactCount > maxContacts,
    [maxContacts, contactCount]
  );

  if (error) {
    return (
      <Container textColor={colours.red}>
        Contact limit reached. Remove{' '}
        {pluralize('contact', contactCount - maxContacts, true)} to continue{' '}
        <InfoIcon />
        <input type='text' className='hidden' required />
      </Container>
    );
  }

  return (
    <Container>
      Add up to {maxContacts - contactCount} more <InfoIcon />
    </Container>
  );
}

InputHelpBlock.propTypes = {
  maxContacts: PropTypes.number.isRequired,
  contactCount: PropTypes.number.isRequired,
};
